import * as React from "react";

interface Props {}

export const EventSvg = (props: Props) => (
	<svg
		width={15}
		height={15}
		viewBox="0 0 15 15"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<circle cx={7.5} cy={7.5} r={7.5} fill="url(#paint0_linear_1_5629)" />
		<path
			d="M9.20899 7.23956V5.0423C9.20899 4.09991 8.44238 3.33331 7.5 3.33331C6.55762 3.33331 5.79102 4.09991 5.79102 5.0423V7.23956L7.54883 7.74412L9.20899 7.23956ZM10.1855 7.4837C10.1855 7.34887 10.0762 7.23956 9.94141 7.23956C9.80658 7.23956 9.69727 7.34887 9.69727 7.4837C9.69727 8.69528 8.71157 9.68097 7.5 9.68097C6.28843 9.68097 5.30273 8.69528 5.30273 7.4837C5.30273 7.34887 5.19342 7.23956 5.05859 7.23956C4.92376 7.23956 4.81445 7.34887 4.81445 7.4837C4.81445 8.88222 5.88905 10.0343 7.25586 10.158V11.1784H6.03516C5.90033 11.1784 5.79102 11.2877 5.79102 11.4225C5.79102 11.5573 5.90033 11.6666 6.03516 11.6666H8.96484C9.09968 11.6666 9.20899 11.5573 9.20899 11.4225C9.20899 11.2877 9.09968 11.1784 8.96484 11.1784H7.74414V10.158C9.11095 10.0343 10.1855 8.88222 10.1855 7.4837Z"
			fill="white"
		/>
		<path
			d="M7.01172 6.75122C7.14655 6.75122 7.25586 6.64191 7.25586 6.50708C7.25586 6.37225 7.14655 6.26294 7.01172 6.26294C6.87689 6.26294 6.76758 6.37225 6.76758 6.50708C6.76758 6.64191 6.87689 6.75122 7.01172 6.75122ZM7.98828 6.75122C8.12311 6.75122 8.23242 6.64191 8.23242 6.50708C8.23242 6.37225 8.12311 6.26294 7.98828 6.26294C7.85345 6.26294 7.74414 6.37225 7.74414 6.50708C7.74414 6.64191 7.85345 6.75122 7.98828 6.75122ZM7.98828 5.77466C8.12311 5.77466 8.23242 5.66535 8.23242 5.53052C8.23242 5.39569 8.12311 5.28638 7.98828 5.28638C7.85345 5.28638 7.74414 5.39569 7.74414 5.53052C7.74414 5.66535 7.85345 5.77466 7.98828 5.77466ZM7.01172 5.77466C7.14655 5.77466 7.25586 5.66535 7.25586 5.53052C7.25586 5.39569 7.14655 5.28638 7.01172 5.28638C6.87689 5.28638 6.76758 5.39569 6.76758 5.53052C6.76758 5.66535 6.87689 5.77466 7.01172 5.77466ZM7.98828 4.7981C8.12311 4.7981 8.23242 4.68879 8.23242 4.55396C8.23242 4.41912 8.12311 4.30981 7.98828 4.30981C7.85345 4.30981 7.74414 4.41912 7.74414 4.55396C7.74414 4.68879 7.85345 4.7981 7.98828 4.7981ZM7.01172 4.7981C7.14655 4.7981 7.25586 4.68879 7.25586 4.55396C7.25586 4.41912 7.14655 4.30981 7.01172 4.30981C6.87689 4.30981 6.76758 4.41912 6.76758 4.55396C6.76758 4.68879 6.87689 4.7981 7.01172 4.7981ZM5.79102 7.2395V7.48364C5.79102 7.56649 5.79688 7.64803 5.80859 7.72778C5.92725 8.55493 6.64046 9.19263 7.5 9.19263C8.35954 9.19263 9.07275 8.55493 9.19141 7.72778C9.20313 7.64803 9.20898 7.56649 9.20898 7.48364V7.2395H5.79102Z"
			fill="#98A2FF"
		/>
		<defs>
			<linearGradient
				id="paint0_linear_1_5629"
				x1={9.54468}
				y1={14.2874}
				x2={6.16609}
				y2={0.743978}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#0019FF" />
				<stop offset={1} stopColor="#717FFF" />
			</linearGradient>
		</defs>
	</svg>
);
